/** Format a USD amount for the comparator UI: `$1,000`, no fractional cents. */
export function formatUsd(amount: number): string {
  return `$${Math.round(amount).toLocaleString("en-US")}`;
}
